const currencyFormatter = new Intl.NumberFormat({
  style: 'currency',
  currency: 'THB',
  maximumFractionDigits: 2,
});

export default currencyFormatter;
